import LinkEnhance from '@/component/LinkEnhance'
import useMediaBreakpoint from '@/hook/useMediaBreakpoint'
import useRuntime from '@/hook/useRuntime'
import { PopUpStore } from '@/store/PopupStore'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const NavItem: React.FC<PropType> = ({ item }) => {
  const { t } = useTranslation()
  const { path } = useRuntime()
  const { size } = useMediaBreakpoint()
  const [active, setActive] = useState(false)
  const { code, name, icon, iconCode, link } = item

  const handleClick = () => {
    size === 'xs' && PopUpStore.setMenuPopupVisible(false)
  }

  useEffect(() => {
    setActive(link.replace(/(^\/|\/$)/g, '') === path.replace(/(^\/|\/$)/g, ''))
  }, [path, link])

  return (
    <div onClick={handleClick}>
      <LinkEnhance className="group/item" href={link}>
        <div
          className={`flex h-8 w-48 border-l-[6px] leading-8 ${active ? 'border-primary bg-primary-light' : 'border-transparent'}`}
        >
          <div className="flex items-center px-4">
            {iconCode && (
              <img
                src={require(`@/asset/svg/menu/${iconCode}`)}
                className="cus_menu-icon aspect-square h-[20px]"
                alt=""
              />
            )}
            {icon && <img src={icon} className="cus_menu-icon aspect-square h-[20px]" alt="" />}
          </div>
          <div className="text-nowrap text-[15px] font-medium leading-8 transition-all duration-150 ease-in-out group-hover:visible group-hover/item:translate-x-2 group-hover/item:opacity-70 sm:invisible 2xl:visible">
            {code && t(`menu.${code}`)}
            {name && name}
          </div>
        </div>
      </LinkEnhance>
    </div>
  )
}

interface PropType {
  item: NavItemType
}

export interface NavItemType {
  code?: string
  name?: string
  iconCode?: string
  icon?: string
  link: string
  active?: boolean
}

export default NavItem
